import { ref as vueRef } from 'vue';

import { IItem } from '../types';

/**
 *
 */
export interface IItemStorageCfg {
  ref: typeof vueRef;
}

const fn = ({ ref }: IItemStorageCfg) => {
  const value = ref<IItem[]>([]);

  const set = (v: IItem[]) => {
    const prefixOoo = 'общество с ограниченной ответственностью';
    const prefixOooLength = prefixOoo.length;

    value.value = v.map(i => {
      const iFullName = i.fullName;
      const iFullNameLower = iFullName.toLowerCase();

      return {
        ...i,
        fullName: iFullNameLower.startsWith(prefixOoo)
          ? 'ООО' + iFullName.slice(prefixOooLength)
          : iFullName,
      };
    });
  };

  return { set, value };
};

export default fn;
